import React, { useState } from 'react'
import EditSettingForm from 'views/admin/configuration/Configuration/EditSettingForm'
import { updateConfigById } from 'store/config'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'

export const Setting = ({ config, fields = [] }) => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const onSave = (values) => {
    startLoading()
    dispatch(
      updateConfigById(
        config?.id,
        values,
        () => {
          toast.success('Successfully saved')
          stopLoading()
        },
        () => {
          toast.error('Failed to save the setting. Please try again.')
          stopLoading()
        }
      )
    )
  }
  if (!config) return null
  return <EditSettingForm fields={fields} values={config} onSave={onSave} isLoading={isLoading} />
}

export default Setting
